import { AnagraficaSocieta } from "./anagrafica-societa";
import { AnagraficaUtente } from "./anagrafica-utente";

export class PrepPratica {
    listaConsulenti: AnagraficaUtente[] = [];
    listaTecnici: AnagraficaUtente[] = [];
    societa: AnagraficaSocieta = new AnagraficaSocieta();
    isSocietaInterna: boolean = false;
    isSocietaIbrida: boolean = false;
}